import Box from '@mui/material/Box';
import CustomButton from '../CustomButton/CustomButton';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from 'context/AuthContext';
import CustomDialog from 'components/dialogs/CustomDialog';
import { useState } from 'react';
import { ListItemButton, ListItemIcon } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useGlobalStyles from 'styles/globalStyles';
import LogoutDialog from 'components/common/LogoutDialog/LogoutDialog';



export default function SidebarLogout({ mini }: { mini: boolean }) {
  const [open, setOpen] = useState<boolean>(false);
  const globalStyles = useGlobalStyles();


  return (
    <>
      <Box mx={1} mb={1}>
        {!mini ? (
          <Box mt={1}>
            <CustomButton
              text='Logout'
              variant='outlined'
              intent='primary'
              fullWidth
              onClick={() => setOpen(true)}
              startIcon={<LogoutIcon />}
            />
          </Box>
        ) : (
          <ListItemButton
            onClick={() => setOpen(true)}
            className={globalStyles.sidebarIconButton}
            sx={{ justifyContent: 'center' }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                justifyContent: 'center',
              }}
            >
              <LogoutIcon sx={{ fontSize: 18 }} />
            </ListItemIcon>
          </ListItemButton>

        )}
      </Box>
      <LogoutDialog
        open={open}
        setOpen={setOpen}
      />
    </>
  );
}
